import useNavigation from 'core/hooks/navigation/useNavigation'
import { useMemo } from 'react'

const useUrlIsAppRequest = () => {
  const { search } = useNavigation()

  const isAppRequest = useMemo(() => {
    const params = new URLSearchParams(search)
    return params.get('is_app_request') === 'true'
  }, [search])

  return isAppRequest
}

export default useUrlIsAppRequest
